import { Col, Row, Spin, Menu, Dropdown, Collapse, Modal } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import serviceAPI from '~/api/ServiceAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import FormContact from '~/components/FormContact';
import ItemService from '~/components/ItemService';
import styles from './Spa.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { FreeMode } from 'swiper';
import { DownOutlined } from '@ant-design/icons';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import branchAPI from '~/api/BranchAPI';
import FormFilterPrice from '~/components/FormFilterPrice';
import { useNavigate } from 'react-router';
import config from '~/config';

const { Panel } = Collapse;

const cx = classNames.bind(styles);

const Spa = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [indexTag, setIndexTag] = useState(0);

    const [idCategory, setIdCategory] = useState('');

    const [listCategory, setListCategory] = useState([]);

    const [listCategoryMobile, setListCategoryMobile] = useState([]);

    const [keySearch, setKeySearch] = useState('');

    const [isShowModalPrice, setIsShowModalPrice] = useState(false);

    const [rangePrice, setRangePrice] = useState({
        priceLow: '',
        priceHight: '',
    });

    const [branchList, setBranchList] = useState([]);

    const [listService, setListService] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 12,
        total_item: 0,
        total_page: 0,
    });

    const handleChangeCategoryDesktop = (value, item) => {
        try {
            setIndexTag(value);
            setIdCategory(item.id);
            if (item.id) {
                handleGetListService([], 1, item.id, filterOrder, keySearch, '', rangePrice);
            } else {
                handleGetListService([], 1, null, filterOrder, keySearch, '', rangePrice);
            }
        } catch (err) {
            console.log(err);
        }
    };
    const handleChangeCategoryMobile = (value, item) => {
        try {
            setIndexTag(value);
            setIdCategory(item.id);
            if (item.id) {
                handleGetListService([], 1, item.id, filterOrder, keySearch, filterBranch.value, rangePrice);
            } else {
                handleGetListService([], 1, null, filterOrder, keySearch, filterBranch.value, rangePrice);
            }
        } catch (err) {
            console.log(err);
        }
    };

    // Get list Category
    const handleGetListCategory = async (cate_id) => {
        try {
            const categories = [
                {
                    id: '',
                    title: 'All',
                },
            ];
            const params = {
                fields: '["$all"]',
                order: '[["order", "ASC"]]',
            };
            const res = await serviceAPI.getListCategoryAPI(params);

            if (res.code === 200) {
                categories.push(...res.results.objects.rows);
            }
            const listCateResults = categories.filter((item) => item.id != '');
            setListCategoryMobile(listCateResults);

            setListCategory(categories);
            if (cate_id) {
                for (let i = 0; i < categories?.length; i++) {
                    if (categories[i].id === cate_id) {
                        setIndexTag(i);
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    };
    // Get list Service
    const handleGetListService = async (list, page, cate_id, orderBy, search, branch_id, range) => {
        try {
            setIsLoading(true);
            let services = list;
            let final = [];
            const filterS = {
                category_service_id: cate_id ? cate_id : undefined,
                title: !search
                    ? undefined
                    : {
                          $iLike: `%${search}%`,
                      },
                branch_id: branch_id ? branch_id : undefined,
                price_deducted:
                    !range?.priceLow && !range.priceHigh
                        ? undefined
                        : { $between: [range?.priceLow || 0, range?.priceHigh] },
            };
            const params = {
                fields: '["$all", {"unit": ["$all"]}]',
                filter: JSON.stringify(filterS),
                order: orderBy ? `[["${orderBy?.type}", "${orderBy?.value}"]]` : null,
                limit: pagination.limit,
                service: search,
                page: page,
            };
            const res = await serviceAPI.getListServiceAPI(params);

            if (res.code === 200) {
                services.push(...res.results.objects.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (services?.length) {
                final = [...new Map(services.map((item) => [item['id'], item])).values()];
            }
            // setServiceListMobile(res.results.objects.rows);
            setListService([...final]);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const handleSetShowModalPrice = () => {
        setIsShowModalPrice(false);
    };

    const handleSeeMoreDesktop = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetListService(listService, nextPage, idCategory, filterOrder, keySearch, '', rangePrice);
        } catch (err) {
            console.log(err);
        }
    };
    const handleSeeMoreMobile = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetListService(
                listService,
                nextPage,
                idCategory,
                filterOrder,
                keySearch,
                filterBranch.value,
                rangePrice,
            );
        } catch (err) {
            console.log(err);
        }
    };

    const getListBranch = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            const res = await branchAPI.getBranchList(params);
            const branches = res?.results?.objects?.rows || [];
            setBranchList([...branches]);
            const branch_main = branches.filter((x) => x.is_main);
            setFilterBranch({
                ...filterBranch,
                title: branch_main.length ? branch_main[0].name : branches[0]?.name,
                value: branch_main.length ? branch_main[0].id : branches[0]?.id,
            });
        } catch (err) {
            console.log(err);
            setBranchList([]);
        }
    };

    useEffect(() => {
        getListBranch();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const cate_id = localStorage.getItem('cate_id');
        setIdCategory(cate_id);
        handleGetListCategory(cate_id);
        handleGetListService([], 1, cate_id ? cate_id : null, filterOrder, keySearch, filterBranch.value, rangePrice);
        localStorage.removeItem('cate_id');
        document.body.classList.remove('time-picker-booking-custom');
        //eslint-disable-next-line
    }, []);

    const renderCate = () => {
        return listCategory?.map((item, index) => {
            return (
                <SwiperSlide
                    key={index}
                    className={cx(indexTag === index ? 'category_selected' : 'category_normal')}
                    onClick={() => handleChangeCategoryDesktop(index, item)}
                >
                    <span key={item?.id}>{item?.title}</span>
                </SwiperSlide>
            );
        });
    };

    const [filterOrder, setFilterOrder] = useState({
        title: 'Price increases gradually',
        value: 'ASC',
        type: 'price_deducted',
    });

    const [filterBranch, setFilterBranch] = useState({
        title: branchList[0]?.name,
        value: branchList[0]?.id,
        type: 'price_deducted',
    });

    const handleSelectFilterOrder = (item) => {
        setFilterOrder(item);
        handleGetListService([], 1, idCategory, item, keySearch, filterBranch.value, rangePrice);
    };

    const handleSelectFilterBranch = (item) => {
        setFilterBranch(item);
        handleGetListService([], 1, idCategory, filterOrder, keySearch, item.value, rangePrice);
    };

    const menuBranchList = (
        <Menu
            items={branchList.map((itemMenu) => {
                return {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterBranch({
                                    title: itemMenu.name,
                                    value: itemMenu.id,
                                    type: 'price_deducted',
                                })
                            }
                        >
                            {itemMenu.name}
                        </p>
                    ),
                    key: itemMenu.id,
                };
            })}
        />
    );

    const menuSort = (
        <Menu
            items={[
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price increases gradually',
                                    value: 'ASC',
                                    type: 'price_deducted',
                                })
                            }
                        >
                            Prices gradually increase
                        </p>
                    ),
                    key: '1',
                },
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price decreasing',
                                    value: 'DESC',
                                    type: 'price_deducted',
                                })
                            }
                        >
                            Prices gradually decrease
                        </p>
                    ),
                    key: '2',
                },
            ]}
        />
    );

    useEffect(() => {
        handleGetListService([], 1, '', filterOrder, keySearch, filterBranch.value, rangePrice);
        // eslint-disable-next-line
    }, [rangePrice]);

    const renderServiceList = () => {
        return isLoading ? (
            <Row justify="center" className={cx('spin')}>
                <Spin />
            </Row>
        ) : (
            <>
                {listService?.length ? (
                    <>
                        <Row className={cx('container_service')}>
                            {listService?.map((item, index) => {
                                return (
                                    <Col xs={24} sm={12} lg={8} key={index}>
                                        <Row>
                                            <ItemService data={item} />
                                        </Row>
                                    </Col>
                                );
                            })}
                        </Row>
                        {pagination?.page < pagination?.total_page && (
                            <Row justify="center" style={{ marginTop: '30px' }}>
                                <div className={cx('btn_see_more_desktop')} onClick={handleSeeMoreDesktop}>
                                    see more
                                </div>
                                <div className={cx('btn_see_more_mobile')} onClick={handleSeeMoreMobile}>
                                    see more
                                </div>
                            </Row>
                        )}
                    </>
                ) : (
                    <div className={cx('no_service')}>
                        <img src={SVGS.IconNoService} alt="" />
                        <span>No service yet</span>
                    </div>
                )}
            </>
        );
    };
    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDanhSachDichVu');
        // eslint-disable-next-line
    }, []);
    return (
        <>
            {/* DESKTOP UI */}
            <div className={cx('service_desktop')}>
                <div className={cx('banner')}>
                    <img src={IMAGES.BannerSpa} alt="Banner Spa" />
                    <span>Service</span>
                </div>
                <div className={cx('service_home_spa')}>
                    <Row justify="center" className={cx('name_section')}>
                        Beauty-ms service
                    </Row>

                    <div className={cx('tags_section')}>
                        <Swiper
                            slidesPerView={'auto'}
                            slidesPerColumnFill="row"
                            slidesPerColumn={1}
                            spaceBetween={30}
                            freeMode={true}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[FreeMode]}
                            className="mySwiper"
                        >
                            {renderCate()}
                        </Swiper>
                    </div>

                    <Row justify="end" className={cx('filter')}>
                        <Col xs={24} sm={12} md={10} xl={8}>
                            <Row justify="end" style={{ width: '100%' }}>
                                <Dropdown overlay={menuSort} trigger={['click']}>
                                    <button onClick={(e) => e.preventDefault()} className={cx('button')}>
                                        <Row align="middle">
                                            <Col xs={16}>
                                                <Row>
                                                    <span>{filterOrder.value ? filterOrder.title : 'Options'}</span>
                                                </Row>
                                            </Col>
                                            <Col xs={8}>
                                                <Row justify="end">
                                                    <DownOutlined />
                                                </Row>
                                            </Col>
                                        </Row>
                                    </button>
                                </Dropdown>
                            </Row>
                        </Col>
                    </Row>

                    {renderServiceList()}
                </div>

                <FormContact />
            </div>

            {/* MOBILE UI */}
            <div className={cx('service_mobile')}>
                <div className={cx('title_header')}>
                    <Row className={cx('header_row')}>
                        <Col>
                            <Row>
                                <span className={cx('header_title')}>Service</span>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.ImageSearch}
                                    alt="icon search"
                                    className={cx('btn_search')}
                                    onClick={() => {
                                        navigate(config.routes.spaFilter);
                                        localStorage.setItem('branch_id', filterBranch?.value);
                                    }}
                                />
                            </Row>
                        </Col>
                    </Row>
                </div>

                <div className={cx('service_home_spa')}>
                    <Collapse className={cx('service_collapse')} accordion>
                        <Row className={cx('branch_select')}>
                            <Col xs={6}>
                                <span className={cx('branch')}>Branch</span>
                            </Col>
                            <Col xs={16}>
                                <Row className={cx('filter_branch_mobile')} align="middle">
                                    <Row style={{ width: '100%' }}>
                                        <Dropdown overlay={menuBranchList} trigger={['click']}>
                                            <button onClick={(e) => e.preventDefault()} className={cx('button')}>
                                                <Row align="middle">
                                                    <Col xs={21}>
                                                        <Row className={cx('title_select')}>
                                                            <span>
                                                                {filterBranch.value ? filterBranch.title : 'Options'}
                                                            </span>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={3}>
                                                        <Row justify="end">
                                                            <img src={SVGS.ImageChevronDown} alt="" />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </button>
                                        </Dropdown>
                                    </Row>
                                </Row>
                            </Col>
                        </Row>

                        {listCategoryMobile?.map((item, index) => (
                            <Panel
                                key={index}
                                showArrow={false}
                                header={
                                    <Row
                                        align="middle"
                                        justify="space-between"
                                        className={cx('service_title')}
                                        onClick={() => handleChangeCategoryMobile(index, item)}
                                    >
                                        <Row align="middle">
                                            <img
                                                className={cx('service_icon')}
                                                src={index % 2 === 0 ? SVGS.IconServiceBlack1 : SVGS.IconServiceBlack2}
                                                alt="icon-service"
                                            />
                                            <span>{item?.title}</span>
                                        </Row>
                                        <img
                                            className={cx('service_cheveron')}
                                            src={SVGS.CheveronDown}
                                            alt="icon-cheveron-down"
                                            style={{ color: '#fff' }}
                                        />
                                    </Row>
                                }
                            >
                                {renderServiceList()}
                            </Panel>
                        ))}
                    </Collapse>
                </div>
            </div>
            <Modal
                centered
                visible={isShowModalPrice}
                onCancel={() => setIsShowModalPrice(false)}
                maskClosable={false}
                footer={null}
                style={{ top: 230 }}
                className="otp-modal-price"
                width={500}
                destroyOnClose
            >
                <div style={{ padding: '0px 0px' }}>
                    <FormFilterPrice
                        title="Filter services"
                        isShowModalPrice={isShowModalPrice}
                        isCancel={handleSetShowModalPrice}
                        rangePrice={rangePrice}
                        setRangePrice={setRangePrice}
                    />
                </div>
            </Modal>
        </>
    );
};

export default Spa;
